<template>
  <div id="workflows" class="container">
    <div  class="row clearfix">
      <UserWorkflowsGroup/>
      <UserWorkflowsWorkflow/>
    </div>
  </div>
</template>


<script>
import UserWorkflowsGroup from "@/views/user/workflows/UserWorkflowsGroup";
import UserWorkflowsWorkflow from "@/views/user/workflows/UserWorkflowsWorkflow";

export default {
  name: 'WorkflowPage',
  components: {
    UserWorkflowsGroup,
    UserWorkflowsWorkflow,
  },
  data() {
    return {
    }
  },
  methods: {
    checkHomeGroup() {
      var param = {userCode: this.userStore.userCode};
      this.api.getGroupList(param).then((res) => {

        if(this.utils.preApiHandle(res)) {
          console.log("profile edit res : ", res)
        }

        console.log("getGroupList res : ", res);
        if (res.code == 0) {
          this.$store.dispatch("saveGroups", res.groups)
          if (res.groups.length <= 0) {
            this.createHomeGroup();
          }
          if (this.workflowStore.groupCode == "") {
            for (var i = 0; i < res.groups.length; i++) {
              if (res.groups[i].groupName == "홈") {

                this.$store.state.workflowStore.groupCode = res.groups[i].groupCode

                // this.$store.dispatch("saveGroupCode", res.groups[i].groupCode);
                // var param2 = {
                //   userCode: this.userStore.userCode,
                //   groupCode: res.groups[i].groupCode,
                // };
                // this.api.getWorkflowList(param2).then((res2) => {
                //   console.log("getWorkflowList res : ", res2);
                //   if (res2["code"] == 0) {
                //     this.$store.dispatch("saveWorkflows", res2.workflows)
                //   }
                // });
              }
            }
          }
        }
      });
    },
    createHomeGroup() {
      var param = {userCode: this.userStore.userCode, groupName: "홈"};
      this.api.createGroup(param)
        .then((res) => {
          console.log("createGroup res : ", res);

          if(this.utils.preApiHandle(res)) {
            console.log("dev create page res : ", res)
          }

          if (res.code == 0) {
            var param2 = {userCode: this.userStore.userCode};
            this.api.getGroupList(param2).then((res2) => {
              console.log("getGroupList res : ", res2);
              if (res2["code"] == 0) {
                this.$store.dispatch("saveGroups", res2.groups);
                for (var i = 0; i < res2.groups.length; i++) {
                  if (res2.groups[i].groupName == "홈") {
                    this.$store.dispatch("saveGroupCode", res2.groups[i].groupCode);
                  }
                }
              }
            });
          }
        });
    },
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
  },
  created() {
    console.log('WorkflowPage created')
    this.checkHomeGroup();
  },
  mounted() {
    console.log('WorkflowPage created')
  },
  beforeDestroy() {
    console.log('WorkflowPage beforeDestroy')
  }
}
</script>
<style lang="scss">
@import "../../assets/css/user/user-workflows.css";
</style>
